import "./Navbar.css"
import whiteLogo from "../../images/whiteLogo.png"
import { NavLink, useLocation } from "react-router-dom"

export default function Navbar() {
    const location = useLocation();
    const handleClick = () => {
        window.scrollTo(0, 0);
    };
    return (
        <nav className="myNav">

            <img className="logo" src={whiteLogo} />
            <ul>
                <NavLink exact to="/" onClick={handleClick} >
                    Home
                </NavLink>
                <NavLink to="/about" onClick={handleClick}>
                    About
                </NavLink>
                <NavLink to="/services" onClick={handleClick} >
                    Services
                </NavLink>
                <NavLink to="/contact" onClick={handleClick}>
                    Contact
                </NavLink>

            </ul>
        
        </nav>
    )
}